import Heading from 'components/global/Heading'
import React from 'react'
import Bilboard from 'assets/images/bilboard.png';
import { Swiper, SwiperSlide } from "swiper/react";

import { Autoplay, Pagination } from "swiper";

const DigitalBilboards = () => {

    return (
        <div className='py-12'>
            <div>
                <Heading
                title='Case Study'
                subTitle='The work we are proud of'
                />
            </div>
            <div className='md:px-20 sm:px-12 px-2 mt-12'>
                <Swiper
                    slidesPerView={3}
                    spaceBetween={25}
                    pagination={{
                        clickable: true,
                    }}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    speed={500}
                    loop={true}
                    modules={[Pagination , Autoplay]}
                    className="bilboard-slider"
                    breakpoints={{
                        1000 : {
                            slidesPerView : 3 ,
                        } ,
                        500 : {
                            slidesPerView : 2
                        } ,
                        200 : {
                            slidesPerView : 1
                        }

                    }}
                >
                    {
                        [...Array(6).keys()].map((item,i) => (
                            <SwiperSlide 
                            className='bg-pure rounded-lg p-2 light-shadow' 
                            key={i}
                            >
                                <div>
                                    <img 
                                    src={Bilboard} 
                                    alt="Case Study" 
                                    className='h-[200px] w-full object-cover rounded-md'
                                    />
                                </div>
                                <h3 className='mt-4 text-lg font-bold text-dark'>Digital Billboard</h3>
                                <p className='text-[15px] text-dark py-4'>8,006 screens</p>
                                <p className='text-[15px] text-dark'>32,33 Impresesions</p>
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
            </div>
        </div>
    )
}

export default DigitalBilboards